import { NgModule} from "@angular/core";
import { CommonModule} from "@angular/common";
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';
import {InfiniteScrollModule} from "../../shared/infinite-scroll/infinite-scroll.module";
import {MatMenuModule} from "@angular/material/menu";
import {NotificationComponent} from "./notification/notification.component";

@NgModule({
  declarations: [
    NotificationPanelComponent,
    NotificationComponent
  ],
  imports: [
    CommonModule,
    InfiniteScrollModule,
    MatMenuModule,
  ],
  exports: [
    NotificationPanelComponent
  ]
})
export class NotificationModule {}
